<template>
  <el-dropdown>
    <el-button type="primary" size="small" icon="el-icon-menu">
      <i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <slot name="prepend-item"></slot>
      <el-dropdown-item
        v-if="displayOpt.orders"
        @click.native="gotoList('/orders/orders', row[idField], 'id')"
        >
        {{ $t('api.orders.name') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.payment || isShowPayment"
        :disabled="displayOpt.disablePayment"
        @click.native="gotoList('/chart/payment', row[idField], 'orders_id')"
        >
        {{ $t('api.payment.name') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.payment || isShowPaymentSet"
        @click.native="gotoList('/chart/payment_set', row[idField], 'orders_id')"
        >
        {{ $t('route.payment_set.name') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.statement"
        @click.native="gotoStatement(row)"
        >
        {{ $t('api.statement.name') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.refund"
        @click.native="gotoList('/orders/refund', row[idField], 'orders_id')"
        >
        {{ $t('api.orders.action.refundList') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.invoice"
        @click.native="gotoList('/orders/invoice', row[idField], 'orders_id')"
        >
        {{ $t('api.orders.action.invoiceList') }}
      </el-dropdown-item>
      <el-dropdown-item
        v-if="displayOpt.receipt"
        @click.native="gotoList('/orders/orders_receipt', row[idField], 'orders_id')"
        >
        {{ $t('api.ordersReceipt.name') }}
      </el-dropdown-item>
      <slot name="append-item"></slot>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

import { getMonthlyRange } from '@/utils/time'

export default {
  name: 'orders-link',
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    idField: {
      type: String,
      default: 'orders_id'
    },
    isShowPayment: {
      type: Boolean,
      default: false
    },
    isShowPaymentSet: {
      type: Boolean,
      default: false
    },
    displayOpt: {
      type: Object,
      default: () => {
        return {
          orders: true,
          payment: true,
          statement: true,
          refund: true,
          invoice: false,
          receipt: false,
          disablePayment: false
        }
      }
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    getMonthlyRange,
    gotoList (path, id, idName) {
      this.$router.push({
        path: `${path}/list?${idName}=${id}&date_range=all`
      })
    },
    gotoStatement (row) {
      let q = (row.statement_id)
        ? `id=${row.statement_id}&date_range=all`
        : `bid=${row.bid}&date_range=` +
          this.getMonthlyRange(row.booking_time) +
          '&date_name=start'
      this.$router.push({
        path: `/chart/statement/statement/list?${q}`
      })
    }
  },
  watch: {
  }
}
</script>
